module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAH0AQMAAACU5pVuAAAABlBMVEWeMDn///+ut+dDAAAAeUlEQVR42u3NAQkAAAgDsPcvrSlEDluBJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFSZT3a73W632+12u91ut9vtdrvdbrfb7Xa73W632+12u91ut9vtdrvdbrfb7Yc7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVRZ+66X9IDThqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lv.png
// module id = 1832
// module chunks = 0